<template>
  <div>
    <Button
      as="a"
      :href="`https://wa.me/?text=${encodeURIComponent(landingPageUrl)}`"
      target="_blank"
      append-icon="share"
      append-icon-prefix="fas"
      color="pink"
    >
      {{ $t('share_on_whatsapp') }}
    </Button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  landingPageUrl: string
}>()
</script>
